import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "../../../_assets/css/custom.css";
import OwlCarousel from "react-owl-carousel2";
import "react-owl-carousel2/lib/styles.css";
import { postMethod } from "../../../_services/_postMethod";
import CustomerHeader from "./components/header";
import CustomerFooter from "./components/footer";
import CustomerBanner from "./components/banner";
import { API_BASE_URL } from "../../../_services/constant";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import CustomerVoucherCom from "./components/voucher";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#000',
    backgroundColor: '#fff'
  },
  categoryBoxWrapper: {
    width: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    aspectRatio: '16/9',
  },
  categoryCard: {
    position: 'relative',
    width: '100%',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.08)',
    transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'pointer',
    aspectRatio: '4/3',
    backgroundColor: '#f8f9fa',
    [theme.breakpoints.up('sm')]: {
      aspectRatio: '16/9',
    },
    '&:hover': {
      transform: 'translateY(-6px)',
      boxShadow: '0 16px 32px rgba(0, 0, 0, 0.16)',
      '& $categoryImg': {
        transform: 'scale(1.06)',
      },
      '& $categoryOverlay': {
        background: 'linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.25) 60%, rgba(0, 0, 0, 0) 100%)',
      },
    },
  },
  categoryImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    transition: 'transform 0.5s ease',
  },
  categoryOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    background: 'linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0) 100%)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    padding: '16px 10px',
    transition: 'background 0.35s ease',
  },
  categoryTitle: {
    color: '#ffffff',
    fontSize: '1.2rem',
    fontWeight: 700,
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
    margin: 0,
    textShadow: '0 2px 6px rgba(0, 0, 0, 0.5)',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.85rem',
      letterSpacing: '0.4px',
    },
  },
}));

const CustomerHome = (props) => {
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm();
  const [isvalid, setValid] = useState(false);
  const [load, setLoad] = useState(false);
  const inputRef = React.createRef(null);
  const inputRef2 = React.createRef(null);
  const [productCategory, setProductCategory] = useState([]);
  const [countInnernal, setCountInnernal] = useState(0);
  const [reviewList, setreviewList] = useState([]);

  const options = {
    responsive: {
      0: {
        items: 2,
        margin: 10
      },
      600: {
        items: 2
      },
      1000: {
        items: 4,
        margin: 40
      }
    },
    dots: false,
    autoplay: false,
    // center:true,
    stagePadding: 10,

    loop: true,
    nav: true,
  };

  const optionsReview = {
    items: 1,
    nav: true,
    dots: true,
    autoplay: false,
    stagePadding: 10,
    margin: 10,
    loop: true,
  };

  const getColClass = (totalItems) => {
    if (totalItems === 1) {
      return "col-12 col-sm-8 col-md-6 col-lg-5 mb-3";
    }
    return "col-6 col-sm-6 col-md-4 col-lg-4 px-2 px-sm-3 mb-3 mb-sm-4";
  };

  const redirectToProduct = (prop) => {
    localStorage.setItem("category_id", prop.category_id);
    localStorage.setItem("jwl_category_banner_path", prop.banner_path);
    window.location.pathname = "customersession/products";
  };
  useEffect(() => {
    setLoad(true);
    postMethod("api/session/category_list_customized", {}).then(
      (data) => {
        setProductCategory(data.data);
        setLoad(false);
      }
    );
    postMethod("api/session/customerReviewlist", {}).then((data) => {
      setreviewList(data.data);
    });
    postMethod("api/session/wishlist", {}).then((data) => {
      setCountInnernal(data.data.length);
    });

  }, []);


  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Backdrop className={classes.backdrop} open={load}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <CustomerHeader count={countInnernal} />
      <CustomerBanner />

      <div className="container py-4" style={{ flex: "1 0 auto" }}>
        <div className="catsectionbx mb-5">
          <div className="row mb-4">
            <div className="col-12 text-center uniq">
              <h2>Shop By Category</h2>
            </div>
          </div>
          <div className="clr"></div>
          <div className="row justify-content-start justify-content-md-center align-items-stretch">
            <div className="col-6 col-sm-4 col-lg-4 botmargn3 d-none d-lg-block d-print-block mb-4">
              <div className="cat1bx toppad5">
                <h3>
                  Discover Our <br />
                  <span>Popular Designs</span>
                </h3>
                <p>
                  Our most loved designs deserve a worthy mention and here
                  they are!
                </p>
              </div>
            </div>
            {productCategory &&
              productCategory.map((prop, i) => {
                return (
                  <div
                    key={i}
                    className={`${getColClass(productCategory.length)} cursor-pointer`}
                    onClick={() => redirectToProduct(prop)}
                  >
                    <div className={classes.categoryCard}>
                      <img
                        src={
                          API_BASE_URL + "CustomerUploads/" + prop.image_path
                        }
                        alt={prop.category_name || "Category"}
                        className={classes.categoryImg}
                      />
                      <div className={classes.categoryOverlay}>
                        {prop.category_name && (
                          <h3 className={classes.categoryTitle}>
                            {prop.category_name}
                          </h3>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="clr"></div>
        </div>

        {reviewList.length > 0 ? (
          <section className="greybg testimonial-section2 homeVoucher topborder pt-4 pb-0 px-3 px-md-4 rounded mb-0" style={{ paddingBottom: "0px", marginBottom: "0px" }}>
            <div className="row text-center mb-0">
              <div className="col-12 uniq">
                <h2>What Our Customer Says</h2>
              </div>
            </div>
            <div className="pb-0 mb-0">
              {reviewList.length > 0 && (
                <>
                  <OwlCarousel ref={inputRef2} options={optionsReview}>
                    {reviewList.map((prop, i) => (
                      <div className="item mt-2" key={i}>
                        <div className="d-flex justify-content-center mb-0">
                          <i className="fa fa-star text-warning"></i>
                          <i className="fa fa-star text-warning"></i>
                          <i className="fa fa-star text-warning"></i>
                          <i className="fa fa-star text-warning"></i>
                          <i className="fa fa-star text-warning"></i>
                        </div>
                        <div className="customerDetail" style={{ width: '100%', overflow: "hidden", borderRadius: "8px", padding: "0 25px" }} >
                          <img
                            src={API_BASE_URL + "customerreviewimage/" + prop.image_path}
                            alt=""
                            style={{ top: 0, left: 0, objectFit: "contain", display: "block" }}
                          />
                          <div className="h4">{prop.customer_name}</div>
                          <p>{prop.review}</p>
                        </div>
                      </div>
                    ))}
                  </OwlCarousel>
                </>
              )}
            </div>
          </section>
        ) : null}
      </div>

      <CustomerFooter />
    </div>
  );
};

export default CustomerHome;
